<template>
  <ThemeProvider :id="ID_LAYOUT_DEFAULT" :color="provideThemeColor">
    <sh-header
      v-if="!isWebview"
      @skipToMainContent="skipToMainContent"
      @skipToFooterContent="skipToFooterContent"
    />
    <!-- TODO: This div should be a main but in order to do that we need to remove all the other mains -->
    <div ref="mainContent" class="main-content" tabindex="-1">
      <slot>
        <nuxt />
      </slot>
    </div>
    <sh-footer ref="footerContent" class="footer-content" tabindex="-1" />
    <critical-error-modal />
    <subscribe-dialog-modal />
    <CookieConsent v-if="!isWebview" />
  </ThemeProvider>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { ThemeProvider } from '@sohohouse/design-system'

import { ID_LAYOUT_DEFAULT } from '~/constants/integration'
import CriticalErrorModal from '~/components/critical-error-modal'
import SubscribeDialogModal from '~/components/subscribe/subscribe-dialog-modal'
import ShHeader from '~/components/sh-header'
import ShFooter from '~/components/sh-footer'
import isEmptyObject from '~/helpers/is-empty-object'
import Theme from '../constants/theme'

const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'DefaultLayout',

  authenticated: true,

  middleware: [
    'isAuthorized',
    'canAccessMemberApp',
    'hasBeenInducted',
    'initializer'
  ],

  components: {
    CriticalErrorModal,
    SubscribeDialogModal,
    ShHeader,
    ShFooter,
    ThemeProvider
  },

  head () {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale
      },
      bodyAttrs: {
        'data-app-id': this.$config.APP_VERSION,
        class: `theme-${this.provideThemeColor}`
      }
    }
  },

  data () {
    return {
      ID_LAYOUT_DEFAULT
    }
  },

  computed: {
    ...mapEnvGetters(['isWebview', 'themeColor']),

    hasProfile () {
      return this.profile && !isEmptyObject(this.profile)
    },

    provideThemeColor () {
      const { theme } = this.$route.meta || {}

      if (this.isWebview) {
        if ([/bedrooms/].some(r => new RegExp(r, 'g').test(this.$route.path))) {
          return Theme.Light
        }

        return Theme.Dark
      }

      return theme || this.themeColor || Theme.Light
    }
  },

  methods: {
    skipToMainContent () {
      this.$refs.mainContent.focus()
    },

    skipToFooterContent () {
      this.$refs.footerContent.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
  body {
    &.isWebview {
      background: $color-black;
    }
  }

  .main-content, .footer-content {
    &:focus {
      outline: none;
    }
  }
</style>
